import * as React from "react";
import { SVGProps } from "react";
const SvgLogoIntercom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-intercom_svg__a)">
      <path
        d="M15.6 9.896a.6.6 0 0 1-1.2 0V4.5a.6.6 0 0 1 1.2 0v5.396Zm-.21 3.756c-.092.08-2.315 1.944-6.39 1.944-4.075 0-6.298-1.865-6.39-1.944a.6.6 0 0 1 .78-.912c.034.03 2.02 1.656 5.61 1.656 3.636 0 5.59-1.639 5.61-1.655a.6.6 0 0 1 .78.91ZM2.4 4.5a.6.6 0 0 1 1.2 0v5.396a.6.6 0 0 1-1.2 0V4.5Zm3-1.2a.6.6 0 0 1 1.2 0v8.016a.6.6 0 0 1-1.2 0V3.3Zm3-.304a.6.6 0 1 1 1.2 0v8.7a.6.6 0 0 1-1.2 0v-8.7Zm3 .304a.6.6 0 0 1 1.2 0v8.016a.6.6 0 0 1-1.2 0V3.3ZM15.75 0H2.25A2.25 2.25 0 0 0 0 2.25v13.5A2.25 2.25 0 0 0 2.25 18h13.5A2.25 2.25 0 0 0 18 15.75V2.25A2.25 2.25 0 0 0 15.75 0Z"
        fill="#1F8DED"
      />
    </g>
    <defs>
      <clipPath id="logo-intercom_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoIntercom;
